import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { ReminderCollection } from '../index'

export const setupReminderReplication = (
  collection: ReminderCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'reminders',
    displayName: 'Reminder',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      taskId: doc.workItemId || doc.taskId, // Backend sends workItemId, map to taskId
      reminderType: doc.reminderType,
      absoluteDate: doc.absoluteDate ? (toTimestamp(doc.absoluteDate) ?? new Date(doc.absoluteDate).getTime()) : null,
      relativeOffsetMinutes: doc.relativeOffsetMinutes,
      notifyUserId: doc.notifyUserId,
      notificationChannel: doc.notificationChannel || 'app',
      isEnabled: doc.isEnabled ?? true,
      isSent: doc.isSent || false,
      sentAt: doc.sentAt ? (toTimestamp(doc.sentAt) ?? new Date(doc.sentAt).getTime()) : null,
      recurrenceType: doc.recurrenceType,
      recurrenceInterval: doc.recurrenceInterval,
      recurrenceDaysOfWeek: doc.recurrenceDaysOfWeek,
      recurrenceDayOfMonth: doc.recurrenceDayOfMonth,
      recurrenceEndDate: doc.recurrenceEndDate ? (toTimestamp(doc.recurrenceEndDate) ?? new Date(doc.recurrenceEndDate).getTime()) : null,
      recurrenceMaxOccurrences: doc.recurrenceMaxOccurrences,
      occurrenceCount: doc.occurrenceCount || 0,
      lastSentAt: doc.lastSentAt ? (toTimestamp(doc.lastSentAt) ?? new Date(doc.lastSentAt).getTime()) : null,
      nextScheduledAt: doc.nextScheduledAt ? (toTimestamp(doc.nextScheduledAt) ?? new Date(doc.nextScheduledAt).getTime()) : null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      workItemId: state.taskId, // Frontend uses taskId, backend expects workItemId
      reminderType: state.reminderType,
      absoluteDate: toISOStringOrNull(state.absoluteDate),
      relativeOffsetMinutes: state.relativeOffsetMinutes,
      notifyUserId: state.notifyUserId,
      notificationChannel: state.notificationChannel || 'app',
      isEnabled: state.isEnabled ?? true,
      isSent: state.isSent || false,
      sentAt: toISOStringOrNull(state.sentAt),
      recurrenceType: state.recurrenceType,
      recurrenceInterval: state.recurrenceInterval,
      recurrenceDaysOfWeek: state.recurrenceDaysOfWeek,
      recurrenceDayOfMonth: state.recurrenceDayOfMonth,
      recurrenceEndDate: toISOStringOrNull(state.recurrenceEndDate),
      recurrenceMaxOccurrences: state.recurrenceMaxOccurrences,
      occurrenceCount: state.occurrenceCount || 0,
      lastSentAt: toISOStringOrNull(state.lastSentAt),
      nextScheduledAt: toISOStringOrNull(state.nextScheduledAt),
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
